<template>
  <nuxt-link :to="`${runtimeConfig.public.eva1Url}/premium`">
    <icon class="icon" name="nomad:diamond" size="2.2rem" />
    S’abonner
  </nuxt-link>
</template>
<script lang="ts" setup>
const runtimeConfig = useRuntimeConfig();
</script>
<style lang="scss" scoped>
a {
  display: inline-flex;
  position: relative;
  align-items: center;
  width: fit-content;
  height: fit-content;
  padding: var(--gap_s) var(--gap_m);
  transition: background-color 300ms $ease-out-quad, color 150ms $ease-in-quad;
  border-radius: var(--stroke_radius_l);
  background-color: var(--color_secondary_lighter);
  color: var(--color_secondary_darker);
  color: var(--color_secondary);
  text-align: center;
  text-transform: uppercase;
  gap: var(--gap_xs);
  @include font('s', 700, 'secondary');
  @include mobile {
    @include font('xs', 700, 'secondary');
  }
  @include above('l') {
    height: 4.4rem;
  }

  @include mobile {
    padding: var(--gap_s) var(--gap_xs);
  }

  .icon {
    transition: transform 300ms $ease-out-back;
  }

  &:hover,
  &.router-link-active,
  &.router-link-exact-active,
  &.child-active,
  &:focus {
    background-color: var(--color_secondary);
    color: var(--color_neutral_25);
    .icon {
      transform: scale(1.4);
    }
  }
}
</style>
